var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRuleLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    stroke: "#9DA1B5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#9DA1B5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.23,
    y: 5.32,
    width: 9.55,
    height: 3.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.59,22.5H5.32A1.91,1.91,0,0,1,4,19.24a1.89,1.89,0,0,1,1.35-.56H20.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.64,
    y1: 18.68,
    x2: 19.64,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.59,1.5V18.68H5.32a1.91,1.91,0,0,0-1.91,1.91V3.41A1.92,1.92,0,0,1,5.32,1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRuleLibrary);
export default __webpack_public_path__ + "static/media/menuRuleLibrary.98a6349583f8a66e988eabcb905f80f9.svg";
export { ForwardRef as ReactComponent };